/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import {
  createAsyncThunk,
} from "@reduxjs/toolkit";
import axios from "axios";
import UserModel from "../model/UserModel";
import { showMessage } from "../../../store/BASE/messageSlice";

// GET requests
export const getUsers = createAsyncThunk(
    "users/fetchUsers",
    async (params, { dispatch }) => {
        try {
            // send request to get projects
            const response = await axios.get(`${process.env.REACT_APP_API_SERVICE_URL}/api/users`);
            // get data from response
            return response.data;
        } catch (error) {
            // show error message
            dispatch(showMessage({ message: error.message, variant: "error" }));
            throw error;
        }
    }
)